(function() {

	window.TJ_IM = {
		emojiMap: {"1f604":{"original":"1f604.png"},"1f60a":{"original":"1f60a.png"},"1f603":{"original":"1f603.png"},"263a":{"original":"263a.png"},"1f609":{"original":"1f609.png"},"1f60d":{"original":"1f60d.png"},"1f618":{"original":"1f618.png"},"1f61a":{"original":"1f61a.png"},"1f633":{"original":"1f633.png"},"1f614":{"original":"1f614.png"},"1f601":{"original":"1f601.png"},"1f61c":{"original":"1f61c.png"},"1f61d":{"original":"1f61d.png"},"1f612":{"original":"1f612.png"},"1f60f":{"original":"1f60f.png"},"1f613":{"original":"1f613.png"},"1f60c":{"original":"1f60c.png"},"1f61e":{"original":"1f61e.png"},"1f616":{"original":"1f616.png"},"1f625":{"original":"1f625.png"},"1f630":{"original":"1f630.png"},"1f628":{"original":"1f628.png"},"1f623":{"original":"1f623.png"},"1f622":{"original":"1f622.png"},"1f62d":{"original":"1f62d.png"},"1f602":{"original":"1f602.png"},"1f632":{"original":"1f632.png"},"1f631":{"original":"1f631.png"},"1f620":{"original":"1f620.png"},"1f621":{"original":"1f621.png"},"1f62a":{"original":"1f62a.png"},"1f637":{"original":"1f637.png"},"1f47f":{"original":"1f47f.png"},"1f47d":{"original":"1f47d.png"},"1f49b":{"original":"1f49b.png"},"1f499":{"original":"1f499.png"},"1f49c":{"original":"1f49c.png"},"1f497":{"original":"1f497.png"},"1f49a":{"original":"1f49a.png"},"2764":{"original":"2764.png"},"1f494":{"original":"1f494.png"},"1f493":{"original":"1f493.png"},"1f498":{"original":"1f498.png"},"2728":{"original":"2728.png"},"1f31f":{"original":"1f31f.png"},"1f4a2":{"original":"1f4a2.png"},"2755":{"original":"2755.png"},"2754":{"original":"2754.png"},"1f4a4":{"original":"1f4a4.png"},"1f4a8":{"original":"1f4a8.png"},"1f4a6":{"original":"1f4a6.png"},"1f3b6":{"original":"1f3b6.png"},"1f3b5":{"original":"1f3b5.png"},"1f525":{"original":"1f525.png"},"1f4a9":{"original":"1f4a9.png"},"1f44d":{"original":"1f44d.png"},"1f44e":{"original":"1f44e.png"},"1f44c":{"original":"1f44c.png"},"1f44a":{"original":"1f44a.png"},"270a":{"original":"270a.png"},"270c":{"original":"270c.png"},"1f44b":{"original":"1f44b.png"},"270b":{"original":"270b.png"},"1f450":{"original":"1f450.png"},"1f446":{"original":"1f446.png"},"1f447":{"original":"1f447.png"},"1f449":{"original":"1f449.png"},"1f448":{"original":"1f448.png"},"1f64c":{"original":"1f64c.png"},"1f64f":{"original":"1f64f.png"},"261d":{"original":"261d.png"},"1f44f":{"original":"1f44f.png"},"1f4aa":{"original":"1f4aa.png"},"1f6b6":{"original":"1f6b6.png"},"1f3c3":{"original":"1f3c3.png"},"1f46b":{"original":"1f46b.png"},"1f483":{"original":"1f483.png"},"1f46f":{"original":"1f46f.png"},"1f646":{"original":"1f646.png"},"1f645":{"original":"1f645.png"},"1f481":{"original":"1f481.png"},"1f647":{"original":"1f647.png"},"1f48f":{"original":"1f48f.png"},"1f491":{"original":"1f491.png"},"1f486":{"original":"1f486.png"},"1f487":{"original":"1f487.png"},"1f485":{"original":"1f485.png"},"1f466":{"original":"1f466.png"},"1f467":{"original":"1f467.png"},"1f469":{"original":"1f469.png"},"1f468":{"original":"1f468.png"},"1f476":{"original":"1f476.png"},"1f475":{"original":"1f475.png"},"1f474":{"original":"1f474.png"},"1f471":{"original":"1f471.png"},"1f472":{"original":"1f472.png"},"1f473":{"original":"1f473.png"},"1f477":{"original":"1f477.png"},"1f46e":{"original":"1f46e.png"},"1f47c":{"original":"1f47c.png"},"1f478":{"original":"1f478.png"},"1f482":{"original":"1f482.png"},"1f480":{"original":"1f480.png"},"1f463":{"original":"1f463.png"},"1f48b":{"original":"1f48b.png"},"1f444":{"original":"1f444.png"},"1f442":{"original":"1f442.png"},"1f440":{"original":"1f440.png"},"1f443":{"original":"1f443.png"},"1f634":{"original":"1f634.png"},"1f46c":{"original":"1F46C.png"},"1f46d":{"original":"1F46D.png"},"1f465":{"original":"1F465.png"},"1f627":{"original":"1F627.png"},"1f626":{"original":"1F626.png"},"1f62f":{"original":"1F62F.png"},"1f62e":{"original":"1F62E.png"},"1f615":{"original":"1F615.png"},"1f61f":{"original":"1F61F.png"},"1f611":{"original":"1F611.png"},"1f610":{"original":"1F610.png"},"1f636":{"original":"1F636.png"},"1f61b":{"original":"1F61B.png"},"1f60e":{"original":"1F60E.png"},"1f619":{"original":"1F619.png"},"1f617":{"original":"1F617.png"},"1f60b":{"original":"1F60B.png"},"1f607":{"original":"1F607.png"},"1f606":{"original":"1F606.png"},"1f605":{"original":"1F605.png"},"1f62c":{"original":"1F62C.png"},"1f600":{"original":"1F600.png"},"1f464":{"original":"1F464.png"},"1f445":{"original":"1F445.png"},"1f635":{"original":"1F635.png"},"1f624":{"original":"1F624.png"},"1f629":{"original":"1F629.png"},"1f62b":{"original":"1F62B.png"}},
			
		// 判断店铺类型是否属于IM类型(店铺类型有WEIXIN、WEB、小程序、旺旺，其中WX、WEB、小程序属于一类)
		isIMType: function(type) {
			return (type == '200063' || type == '200067' || type == '200070' || type == "200999")
		},

		// 添加字符串到焦点处
		addStrToFocus: function($textarea, str, callback) {
			$textarea.focus();
			var sel = window.getSelection();
			if (sel.getRangeAt && sel.rangeCount) {
				var el = document.createElement("div"),
					frag = document.createDocumentFragment(),
					node,
					lastNode;
				
				var range = sel.getRangeAt(0);
				range.deleteContents();
				el.innerHTML = str;
				while ( (node = el.firstChild) ) {
					lastNode = frag.appendChild(node);
				}
				range.insertNode(frag);
				if (lastNode) {
					range = range.cloneRange();
					range.setStartAfter(lastNode);
					range.collapse(true);
					sel.removeAllRanges();
					sel.addRange(range);
				}
			}
			if (callback && typeof callback == 'function') callback($textarea.innerHTML);
		},

		// 把文本中所有的链接文本转为超链接地址(图片地址不转换)
		strToLink: function(str) {
			var strRegex = '(src="http|src=\'http|http://|ftp://|https://|www)(([^\u4e00-\u9fa5\\s]*?\\.(com|xin|net|cn|top|org|cc|me|tw|fr))|((\\d+\\.){3}\\d+))[^\u4e00-\u9fa5\\s<]*',
				reg = new RegExp(strRegex, "gi");

			return str.replace(reg, function(m){
				var temp = m.toLocaleLowerCase();
				if (temp.indexOf('src') == 0) return m;

				// 旺旺语音消息处理
				if (temp.indexOf('https://interface.im.taobao.com/mobileimweb/fileupload/downloadprifile.do?type=2') == 0) {
					return '<span class="voice-msg js-play-voice" data-file="' + m + '"></span>';
				}

				var headStr = (temp.indexOf('http://') == -1 && temp.indexOf('https://') == -1) ? 'http://' : '';
				return '<a href="'+ headStr + m +'" target="_blank">'+ m +'</a>';
			});
		},

		// 把html代码中gif表情图片转换为对应表情代码
		gifToEmotionsCode: function(html, shopType) {
			var self = this,
				jsonMap = self.isIMType(shopType) ? TJ_WXEmoji : TJ_WWEmoji;

			html = html.replace(/<\s*img\s+src=("|')(.+?)("|')\s*data-type=("|')emotions("|')\s*\/?>/gi, function(word){
				var src = word.match(/src\s*=\s*("|')(.+?)("|')/)[2];

				if (src.indexOf('pic:emotion|') == -1) {
					var imgName = getImgName(src),
						code = imgName ? getEmotionsCode(imgName) : '';
				} else {
					var code = unescape(src.replace('pic:emotion|', ''));
				}
				return code;
			});
			return html;
		
			// 获取图片名称
			function getImgName(src) {
				var name = '';
				if (src.lastIndexOf("/") != -1) {
					name = src.substring(src.lastIndexOf("/") + 1).trim();
				}
				return name;
			}
			// 通过图片名称获取对应的表情代码
			function getEmotionsCode(name) {
				var code = '';
				for(var key in jsonMap) {
					var obj = jsonMap[key];
					if (obj.original == name) {
						code = key;
						break;
					}
				}
				return code;
			}
		},

		// 把html代码中带有对应表情符号的图片转换为gif表情图片
		emotionsCodeToGif: function(html, shopType) {
			var self = this,
				jsonMap = self.isIMType(shopType) ? TJ_WXEmoji : TJ_WWEmoji,
				srcPath = self.isIMType(shopType) ? '/static/image/expression/' : '/static/image/emotions/',
				$str = $('<div>' + replaceFaceEmoji(html) + '</div>'),
				$imgs = $str.find('img[data-type="emotions"]');
			
			$imgs.each(function() {
				var $curEmo = $(this),
					code = getEmotionsCode($curEmo.attr('src')),
					gifName = getEmotionGif(unescape(code));

				if (gifName) {
					$curEmo.attr('src', srcPath + gifName);
				}
			});

			return self.emojiToPic($str.html());
		
			// 获取表情代码
			function getEmotionsCode(src) {
				var code = src.substring(src.lastIndexOf("|") + 1).trim();
				return code;
			}
			// 获取表情动画
			function getEmotionGif(code) {
				var gif = '';
				if (jsonMap[code]) {
					gif = jsonMap[code].original;
				}
				return gif;
			}
			// 把表情代码文本替换为对应的gif表情图片
			function escapeRegExp(str) {
			  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
			}
			function replaceFaceEmoji(content) {
				if(content == null || content == '') return '';
				for (var key in jsonMap) {
					var reg = new RegExp(escapeRegExp(key), 'g');
					content = content.replace(reg, function(r){
						return '<img src="' + srcPath + getEmotionGif(r) + '"/>';
					});
				}
				return content;
			}
		},

		// 把html代码中带有对应表情符号的图片转换为对应的表情文本
		emotionsCodeToTxt: function(html, shopType) {
			var self = this,
				jsonMap = self.isIMType(shopType) ? TJ_WXEmoji : TJ_WWEmoji,
				$str = $('<div>' + replaceFaceEmoji(html) + '</div>'),
				$imgs = $str.find('img[data-type="emotions"]');
			
			$imgs.each(function() {
				var $curEmo = $(this),
					code = getEmotionsCode($curEmo.attr('src')),
					txt = getEmotionTxt(unescape(code));
					
				if (txt) {
					$curEmo.replaceWith('[' + txt + ']');
				}
			})
			return self.emojiToTxt($str.html());
		
			// 获取表情代码
			function getEmotionsCode(src) {
				var code = src.substring(src.lastIndexOf("|") + 1).trim();
				return code;
			}
			// 获取表情说明文本
			function getEmotionTxt(code) {
				var txt = '';
				if (jsonMap[code]) {
					txt = jsonMap[code].meaning;
				}
				return txt;
			}
			// 把表情代码文本替换为对应的说明
			function escapeRegExp(str) {
			  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
			}
			function replaceFaceEmoji(content) {
				if(content == null || content == '') return '';
				for (var key in jsonMap) {
					var reg = new RegExp(escapeRegExp(key), 'g');
					content = content.replace(reg, function(r){
						return '[' + getEmotionTxt(r) + ']';
					});
				}
				return content;
			}
		},

		// 前端收到的emoji类型的图片转换为对应的表情图片
		emojiToPic: function(html) {
			var self = this,
				$str = $('<div>' + html + '</div>'),
				$imgs = $str.find('img[data-type="emojis"]');
			
			$imgs.each(function() {
				var $curEmo = $(this),
					code = getEmotionsCode($curEmo.attr('src')),
					gifName = getEmotionGif(code);
					
				if (gifName) {
					$curEmo.attr('src', '/static/image/emojis/' + gifName);
				}else{
					$curEmo.replaceWith('<span style="font-size:22px">&#x' + code + ';</span>');
				}
			})
			return $str.html();
		
			// 获取表情代码
			function getEmotionsCode(src) {
				var code = src.substring(src.lastIndexOf("|") + 1).trim();
				return code;
			}
			// 获取表情动画
			function getEmotionGif(code) {
				code = code.toLowerCase();
				var gif = '';
				if (self.emojiMap[code]) {
					gif = self.emojiMap[code].original;
				}
				return gif;
			}
		},

		// 前端收到的emoji类型的图片转换为对应的文本
		emojiToTxt: function(html) {
			var self = this,
				$str = $('<div>' + html + '</div>'),
				$imgs = $str.find('img[data-type="emojis"]');
			
			$imgs.each(function() {
				var $curEmo = $(this),
					code = getEmotionsCode($curEmo.attr('src'));
					
				$curEmo.replaceWith('[表情]');
			})
			return $str.html();
		
			// 获取表情代码
			function getEmotionsCode(src) {
				var code = src.substring(src.lastIndexOf("|") + 1).trim();
				return code;
			}
		},

		// 把html转换为纯文本(更新左侧会话列表时调用)
		msgHtmlToTxt: function(html, shopType) {
			var self = this,
				isCommodityCard = self.commodityJsonToHtml(html);

			if (isCommodityCard) {
				return '[卡片消息]';
			} else {
				html = self.gifToEmotionsCode(html, shopType);
				html = self.emotionsCodeToTxt(html, shopType);
				var $str = $('<div>' + html + '</div>');

				$str.find('img').each(function() {
					var src = $(this).attr('src').trim();
					if (src.substring(src.length - 4) == '.mp3') {
						$(this).replaceWith('[语音]');
					} else {
						$(this).replaceWith('[图片]');
					}
				});

				var text = $str.text();
				if (text.toLocaleLowerCase().indexOf('https://interface.im.taobao.com/mobileimweb/fileupload/downloadprifile.do?type=2') == 0) {
					text = '[语音]';
				}
				return text;
			}
		},

		// 把html转换为对话信息(把信息插入到对话框时调用)
		msgHtmlToDialogue: function(html, shopType) {
			var self = this,
				isCommodityCard = self.commodityJsonToHtml(html);

			if (isCommodityCard) {
				return isCommodityCard;
			} else {
				html = self.emotionsCodeToGif(html, shopType);
				html = self.strToLink(html);
				return html;
			}
		},

		// 把html转换为发送出去的消息
		htmlToMsgContent: function(html, shopType) {
			var self = this,
				$tpl = $('<div>' + html + '</div>'),
				obj = {};

			// 先把html中的img替换为{img*}
			$tpl.find('img').each(function(index){
				obj['imgfd43rfea' + index] = $(this).prop('outerHTML');
				$(this).replaceWith('{imgfd43rfea' + index + '}');
			});
			// 再把div替换为 <br> + div的text()文本
			$tpl.children('div').each(function(){
				var txt = $(this).text();
				$(this).replaceWith('<br>' + txt);
			});
			// 再把所有的<br>替换为文本
			var tempHtml = $tpl.html().replace(/<br>/g, '{brfwe5dahy45r}');
			// 现在所有图片和换行符都替换成文本了，直接取这段代码的text()，再把换行符文本替换回<br>
			html = $tpl.html(tempHtml).text().replace(/{brfwe5dahy45r}/g, '<br>');
			// 最后再把{img*}替换为对应的图片
			html = html.format(obj);
			return self.gifToEmotionsCode(html.trim(), shopType);

			// PS: imgfd43rfea  brfwe5dahy45r 这些个字符串是瞎写的作为临时替换的文本，后来的兄弟姐妹看到了别疑虑
		},

		// 商品卡片json信息转换为对应的卡片样式
		commodityJsonToHtml: function(html) {
			var self = this;

			try {
				var json = JSON.parse(html);
				if (json.card_info || json.card_img || json.card_link || json.card_title) {
					return '<div class="card-container">\
								<div class="content-container">\
									<div class="img-box"><a ' + (json.card_link ? 'target="_blank"' : '') + ' href="' + (json.card_link || 'javascript:;') + '" style="background-image: url(' + (json.card_img || '') + ')"></a></div>\
									<div class="content-box">\
										<h3 class="title"><a ' + (json.card_link ? 'target="_blank"' : '') + ' href="' + (json.card_link || 'javascript:;') + '">' + (json.card_title || '??') + '</a></h3>\
										<div class="info">' + (json.card_info || '') + '</div>\
									</div>\
								</div>\
							</div>';
				} else if (json.detailUrl === undefined || json.imgUrl === undefined || json.sourceTip === undefined || json.svText1 === undefined || json.svText2 === undefined) {
					return false;
				} else {
					var html = '<a class="commodity-card" href="' + json.detailUrl + '" target="_blank">\
									<div class="card-head">' + json.sourceTip + '</div>\
									<div class="card-content clear">\
										<div class="pic" style="background-image:url(\'' + json.imgUrl + '\')"></div>\
										<div class="content">\
											<p class="title">' + json.svText1 + '</p>\
											<p class="info">' + json.svText2 + '</p>\
										</div>\
									</div>\
								</a>';
					return html;
				}
			} catch (e) {
				return false;
			}
		},
			
		// 点击聊天记录里的图片，放大显示
		zoomImImg: function($img) {
			var src = $img.attr('src'),
				$modal = $('<div class="TJ_IMZoomImg">\
					<div class="ti_shade"></div>\
					<span class="ti_close"></span>\
					<img src="'+ src +'">\
				</div>');
			
			$modal.appendTo('body');
			$modal.find('img').css({
				"margin-top": -$modal.find('img').height()/2
			})
			
			$modal.off('click.shade').on('click.shade', '.ti_shade', function() {
				$modal.remove();
				
			}).off('click.close').on('click.close', '.ti_close', function() {
				$modal.remove();
			})
		},

		// 播放语音消息(旺旺语音)
		playVoice: function($this) {
			var file = $this.data('file'),
				url = $('.js-msg-list').data('voice'),
				data = {
					link: file
				};
			
			if($this.hasClass('play') || $this.data('pending')) return;
			$('.js-msg-list').find('.js-play-voice').each(function(){
				$(this).removeClass('play');
			});

			if ($this.data('url')) {
				play($this.data('url'));
				return;
			}
			
			$this.data('pending', true);
			$.post(url, data).done(function(result) {
				$this.data('pending', false);
				if (!result.status) {
					$.alert('无法播放该音频文件，错误原因：' + result.message);
				} else {
					$this.data('url', result.data);
					play(result.data);
				}
			}).fail(function(e) {
				$this.data('pending', false);
				$.alert('无法播放该音频文件，错误码(' + e.status + ')');
			});

			function play (url) {
				if(self.$voice) self.$voice.stop();
				$this.addClass('play');
				var xhr = new XMLHttpRequest();
				xhr.open('GET', url);
				xhr.responseType = 'blob';
				xhr.onload = function() {
					readBlob(this.response, function(data) {
						playAmrArray(data);
					});
				};
				xhr.onerror = function() {
					$.alert('Failed to fetch ' + url);
				};
				xhr.send();
			}
			function readBlob(blob, callback) {
				var reader = new FileReader();
				reader.onload = function(e) {
					var data = new Uint8Array(e.target.result);
					callback(data);
				};
				reader.readAsArrayBuffer(blob);
			}
			function playAmrArray(array) {
				var samples = TJ_AMR.decode(array);
				if(!samples) {
					$.alert('Failed to decode!');
					return;
				}
				playPcm(samples);
			}
			function playPcm(samples) {
				try {
					var ctx = new AudioContext();
				} catch(e) {
					$.alert('您的浏览器暂不支持播放录音');
					return;
				}
				self.$voice = ctx.createBufferSource();
				var buffer = ctx.createBuffer(1, samples.length, 8000);
				if(buffer.copyToChannel) {
					buffer.copyToChannel(samples, 0, 0);
				} else {
					var channelBuffer = buffer.getChannelData(0);
					channelBuffer.set(samples);
				}
				self.$voice.buffer = buffer;
				self.$voice.connect(ctx.destination);
				self.$voice.start();
				self.$voice.onended = function() {
					$this.removeClass('play');
				}
			}

		},
			
		// 播放微信语音
		playAudio: function($this){
			if(!$this.data('started')){
				$this.data("started",true);
				var audio = $this.next()[0];
				$this.addClass("play");
				audio.play();
				audio.addEventListener('ended', function () {  
					$this.removeClass("play");
					$this.data("started",false);
				}, false);
			}
		},

		// 根据html代码返回这段代码的类型(1：文本， 2：图片， 3：图文 (PS：表情图片算文本信息))
		htmlToMsgType: function(html) {
			var self = this,
				tempStr = html.replace(/<\s*img src="pic:emotion\s*.+?\s*\/?>/g, ''),
				hasEmotionsImg = (html.length != tempStr.length), // 是否有表情图片
				hasImg = $('<div>' + tempStr + '</div>').find('img').length, // 除开表情图片后是否还有其他图片
				hasTxt = !!$('<div>' + html + '</div>').text().trim(); // 是否有文字

			if (hasImg) {
				if (hasEmotionsImg || hasTxt) {
					return 3;
				} else {
					return 2;
				}
			} else {
				return 1;
			}
		},

		// 显示本地图片
		previewHandle: function(uploadUrl, file, callback) {
			var self = this,
				reader = '',
				imageType = /^image\//,
				imgSign = +new Date(),
				$img = $('<img data-type="uploading" data-upload-sign="' + imgSign + '" />');

			// 文件是否为图片
			if (!imageType.test(file.type)) {
				$.alert("请选择图片！");
				return;
			}
			// 判断是否支持FileReader    
			if (window.FileReader) {
				reader = new FileReader();
			} else {
				console.log("您的浏览器不支持图片预览功能，如需该功能请升级您的浏览器！");
				self.uploadLocalImgFile(uploadUrl, file, function(src) {
					if (src) {
						$('.ima_textarea').append('<img src="' + src + '" />');
					} else {
						alert('上传图片失败');
					}
				});
				return;
			}

			$('.js-send-msg-pic input[type="file"]').val('');
			$img.appendTo($('.ima_textarea'));
			// 读取完成    
			reader.onload = function (event) {
				$img[0].src = event.target.result;
				reader = null;
				if (callback && typeof callback == 'function') callback($('.ima_textarea').html());
			};
			reader.readAsDataURL(file);
		},

		// 将base64图片代码转换为文件
		dataURLtoFile: function(dataurl) {
			var self = this,
				arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n),
				tempArr = mime.split('/'),
				filename = tempArr[1] ? ('image.' + tempArr[1]) : 'image.png';

			while(n--){
				u8arr[n] = bstr.charCodeAt(n);
			}

			return new File([u8arr], filename, {type:mime});
		},

		// 本地图片上传成功后更新数据
		updateFormDataToUploadSuccess: function(uploadSign, src, html) {
			var self = this,
				$obj = $('<div>' + html + '</div>'),
				$img = $obj.find('img[data-upload-sign="' + uploadSign + '"]'),
				oldHtml = $img.prop('outerHTML');

			$img.attr('src', src).removeAttr('data-upload-sign').removeAttr('data-type');
			// 这里用字符串替换的方式而不直接返回$obj.html()，主要是为了避免传进来的html中含有 "<" 或 ">" 符号的表情代码给解析掉
			return html.replace(oldHtml, $img.prop('outerHTML'));
		},
			
		// 粘贴图片
		pasteUploadImg: function(uploadUrl, pasteEvent, callback){
			var self = this, image, text;

			if (pasteEvent.clipboardData && pasteEvent.clipboardData.items) {
				image = isImage(pasteEvent);
				if (image) {
					pasteEvent.preventDefault();
					self.previewHandle(uploadUrl, image.getAsFile(), callback);
				}
			}

			// 判断是否为图片
			function isImage(data) {
				var i, item;
				i = 0;
				while (i < data.clipboardData.items.length) {
					item = data.clipboardData.items[i];
					if (item.type.indexOf("image") !== -1) return item;
					i++;
				}
				return false;
			}
		},

		// 获取上传七牛的key值
		getQiniuToken: function(getTokenUrl, file, callback) {
			var self = this,
				fileName = file.name,
				index = fileName.lastIndexOf("."),
				data = {
					prefix: fileName.substring(0, index),
					ext: fileName.substring(index + 1, fileName.length)
				};

			if (file.response) return;

			var newData = "";
			for(var i in data){
				newData += i + "=" + data[i] + "&";
			}
			newData = newData.substring(0, newData.length - 1);

			$.ajax({
				url: getTokenUrl, 
				data: newData,
				method: 'post',
				success: function (result) {
					if (result.status) {
						callback(result.data.data);
					} else {
						callback();
					}
				},
				error: function () {
					callback();
				}
			})
		},

		// 上传本地的图片
		uploadLocalImgFile: function(getTokenUrl, file, callback) {
			var self = this;

			self.getQiniuToken(getTokenUrl, file, function(result) {
				if (!result) {
					if(callback && typeof callback == 'function') callback('');
					return;
				}

				var formData = new FormData();
				formData.append('file', file);
				formData.append('token', result.token);
				formData.append('key', result.key);

				$.ajax({
					url: '//upload.qiniup.com',
					data: formData,
					type: 'post',
					contentType: false,
					processData: false, 
					success: function (data) {
						if(callback && typeof callback == 'function') callback(result.domain + '/' + data.key);
					},
					error: function (xOptions, textStatus) {
						if(callback && typeof callback == 'function') callback('');
					}
				});
			});
		}
	}
})();

Date.prototype.format = function(format) {  
	/**
	 * eg:format="yyyy-MM-dd hh:mm:ss";
	 */
	var o = {
		"M+" : this.getMonth() + 1, // month
		"d+" : this.getDate(), // day
		"h+" : this.getHours(), // hour
		"m+" : this.getMinutes(), // minute
		"s+" : this.getSeconds(), // second
		"q+" : Math.floor((this.getMonth() + 3) / 3), // quarter
		"S" : this.getMilliseconds()
	}
	
	if (/(y+)/.test(format)) {
		format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(format)) {
			format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
		}
	}
	return format;
}


String.prototype.format = function(args) {
	var result = this;
	if (arguments.length > 0) {
		if (arguments.length == 1 && typeof (args) == "object") {
			for (var key in args) {
				if (args[key] != undefined) {
					var reg = new RegExp("({" + key + "})", "g");
					result = result.replace(reg, args[key]);
				}
			}
		} else {
			for (var i = 0; i < arguments.length; i++) {
				if (arguments[i] != undefined) {
					var reg = new RegExp("({)" + i + "(})", "g");
					result = result.replace(reg, arguments[i]);
				}
			}
		}
	}
	return result;
}


// WEBPACK FOOTER //
// ./src/assets/scripts/TJ_IM.js